import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPackageTypeCategoryType implements BaseEnumType {
  private static allValues: EnumPackageTypeCategoryType[] = []; // make sure this is top-most
  
  public static unknown = new EnumPackageTypeCategoryType(0, "Unknown", "enum_package_type_category_type_unknown");
  public static cask = new EnumPackageTypeCategoryType(1, "Cask", "enum_package_type_category_type_cask");
  public static keg = new EnumPackageTypeCategoryType(2, "Keg", "enum_package_type_category_type_keg");
  public static case = new EnumPackageTypeCategoryType(3, "Case", "enum_package_type_category_type_case");
  public static bottle = new EnumPackageTypeCategoryType(4, "Bottle", "enum_package_type_category_type_bottle");
  public static other = new EnumPackageTypeCategoryType(5, "Other", "enum_package_type_category_type_other");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPackageTypeCategoryType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumPackageTypeCategoryType.unknown; }
  public isCask() { return this === EnumPackageTypeCategoryType.cask; }
  public isKeg() { return this === EnumPackageTypeCategoryType.keg; }
  public isCase() { return this === EnumPackageTypeCategoryType.case; }
  public isBottle() { return this === EnumPackageTypeCategoryType.bottle; }
  public isOther() { return this === EnumPackageTypeCategoryType.other; }

  public static getValues(): readonly EnumPackageTypeCategoryType[] {
    return EnumPackageTypeCategoryType.allValues;
  }

  public static getValuesExcept0(): readonly EnumPackageTypeCategoryType[] {
    return EnumPackageTypeCategoryType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPackageTypeCategoryType {
    const found = EnumPackageTypeCategoryType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPackageTypeCategoryType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPackageTypeCategoryType): EnumPackageTypeCategoryType {
    const found = name ? EnumPackageTypeCategoryType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPackageTypeCategoryType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPackageTypeCategoryType>): boolean {
    return this.key === other?.key;
  }
}